<template>
  <div style="display:flex; flex-direction:column"
       :style="{height: height, width:width}"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh"
       v-if="showComponent"
  >
    <ks-spinner :ref="'input-rich-editor-loading-'+_uid"/>

    <label v-if="label!==null">
      {{ label }}
      <span style="color:red">
            {{ required ? '*' : '' }}
        </span>
    </label>
    <template v-if="showRteTabs">
      <ul class="nav nav-tabs justify-content-end">
        <li class="nav-item">
          <a class="nav-link active pointer" data-toggle="tab" data-target="#richEditor"
             @click.prevent="showWysiwyg = true">Rich Text</a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer" data-toggle="tab" data-target="#html"
             @click.prevent="showWysiwyg = false">HTML</a>
        </li>
      </ul>
      <div class="tab-content" style="height: calc(100% - 54px);">
        <div class="active" id="richEditor" style="height: calc(100% - 46px);" v-if="showWysiwyg">
          <vue-editor
              style="width: 100%; height: 100%;"
              :key="`rich-editor-key-${_uid}-${screenSizeId}`"
              :ref="`rich-editor-ref-${_uid}`"
              use-custom-image-handler
              v-model="input"
              :placehoder="placeholder"
              :required="required"
              :disabled="disabled||!enableComponent"
              :editorOptions="editorOptions"
              @click="onClick"
              @change="onChange"
              @focus="onFocus"
              @blur="onBlur"
              @keyup="onKeyPress"
              @keypress.enter="onKeyPressEnter"
              @keydown.tab="onKeyDownTab"
              @image-added="imageAdded"
              @ready="onReady"
              @text-change="onTextChange"
          />
        </div>
        <div class="fade" id="html" style="height: 100%;" v-else>
                <textarea
                    style="width: 100%; height: 100%;"
                    class="form-control"
                    :rows="rows"
                    v-model="input"
                    :required="required"
                    :disabled="disabled||!enableComponent"
                />
          <!--                    @click="onClick"
                              @change="onChange"
                              @focus="onFocus"
                              @blur="onBlur"
                              @keyup="onKeyPress"
                              @keypress.enter="onKeyPressEnter"
                              @keydown.tab="onKeyDownTab"-->
        </div>
      </div>
    </template>
    <template v-else>
      <vue-editor
          style="width: 100%; height: 100%;"
          :key="`rich-editor-key-${_uid}-${screenSizeId}`"
          :ref="`rich-editor-ref-${_uid}`"
          use-custom-image-handler
          v-model="input"
          :placehoder="placeholder"
          :required="required"
          :disabled="disabled||!enableComponent"
          :editorOptions="editorOptions"
          @click="onClick"
          @change="onChange"
          @focus="onFocus"
          @blur="onBlur"
          @keyup="onKeyPress"
          @keydown.tab="onKeyDownTab"
          @image-added="imageAdded"
          @ready="onReady"
          @text-change="onTextChange"
      />
    </template>

    <div class="invalid-feedback" style="display:block !important" v-for="error of errors">{{ error }}</div>

    <ks-modal-new
        :ref="`inputRichTextEditFile${_uid}`"
        position="centered"
        title="Upload Images"
        :backdropClose="false"
        :showHeader="false"
        :modalWidth="screenSizeId >= 3 ? '75' : '100'"
    >
      <ks-modal-body>
        <ks-image-cropper
            :ref="`inputRichTextEditFileCropper${_uid}`"
            :src="tmpFile.src"
            :fileName="tmpFile.name"
        />
      </ks-modal-body>
      <ks-modal-footer>
        <button
            class="btn btn-danger"
            @click.prevent="cancelCrop()"
        >
          Cancel
        </button>
        <button
            class="btn btn-primary"
            type="button"
            @click.prevent="uploadCrop()"
            style="border-right: 3px solid #ced4da !important;"
        >
          <i class="fa fa-save"></i> Save
        </button>
      </ks-modal-footer>
    </ks-modal-new>
  </div>
</template>
<script>
import checkPermissions from '../../../mixins/checkPermissions';
import fileTypeIs from '../../../mixins/fileTypeIs';
import {VueEditor, Quill} from 'vue2-editor';
import {ImageDrop} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module--fix-imports-error'
import MagicUrl from 'quill-magic-url'

Quill.register('modules/magicUrl', MagicUrl)
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)


export default {
  name:       'input-rich-text',
  mixins:     [checkPermissions, fileTypeIs],
  props:      {
    stopOnEnter:   {type: Boolean, default: false},
    smallToolBar:  {
      type:    Array,
      default: () => ['bold', 'italic', {'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}, {'indent': '-1'}, {'indent': '+1'}]
    },
    value:         {default: null},
    dataSource:    {type: String, default: null},
    placeholder:   {type: String, default: null},
    defaultValue:  {},
    showRteTabs:   {type: Boolean, default: true},
    height:        {type: String, default: "100%"},
    width:         {type: String, default: "100%"},
    label:         {type: String, default: null},
    required:      {type: Boolean, default: false},
    disabled:      {type: Boolean, default: false},
    rows:          {type: String},
    focus:         {type: Boolean, default: false},
    uploadOptions: {
      type:    Object,
      default: () => {
        return {
          campaign_id:       null,
          object_type_id:    null,
          object_id:         null,
          transform_type_id: 1
        }
      }
    },
    /* for remove/update */
    set_rte_focus: {type: Boolean, default: false}
  },
  components: {VueEditor, Quill},
  watch:      {
    value(val) {
      this.input = val;
    },
    input(val, oldVal) {
      this.$emit('input', val);
    },
    focus:         function (val) {
      if (val) {
        let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
        quill.focus();
      }
    },
    set_rte_focus: function (val, oldVal) {
      let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
      setTimeout(function () {
        quill.focus();
      });
    },
    defaultValue:  function (val) {
      this.input = val;
    }
  },
  computed:   {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    inputType() {
      return this.$parent.type;
    },
    input: {
      get() {
        if (this.dataSource == null) return this.l_input;
        if (this.inputType === 'list') {
          let val = this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
          return val;
        } else {
          let val = this.$parent.data_provider_ref[this.inputType][this.dataSource];
          return val;
        }
      },
      set(newval) {
        if (this.dataSource !== null) {
          if (this.inputType === 'list') {
            this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
          } else {
            this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
          }
        } else {
          this.l_input = newval;
        }
      }
    },
    editorOptions() {
      let magicUrlSettings = {
        // Regex used to check URLs during typing
        urlRegularExpression: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/g,
        // Regex used to check URLs on paste
        globalRegularExpression: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/g,
      };

      let imageResizeSettings = {
        displayStyles: {
          backgroundColor: 'black',
          border:          'none',
          color:           'white'
        },
        modules:       ['Resize', 'DisplaySize', 'Toolbar']
      };

      let editorSettingsSmall = {
        modules: {
          toolbar:     [
            this.smallToolBar
          ],
          imageDrop:   true,
          imageResize: imageResizeSettings,
          keyboard:    {
            bindings: {
              shift_enter: {
                key:      13,
                shiftKey: true,
                handler:  (range, ctx) => {
                  let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
                  quill.insertText(range.index, '\n');
                }
              },
              enter:       {
                key:     13,
                handler: (range, ctx) => {
                  if (!this.stopOnEnter) {
                    let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
                    quill.insertText(range.index, '\n');
                  }
                }
              }
            }
          }
        }
      }
      let editorSettings      = {
        modules: {
          imageDrop:   true,
          imageResize: imageResizeSettings,
          keyboard:    {
            bindings: {
              shift_enter: {
                key:      13,
                shiftKey: true,
                handler:  (range, ctx) => {
                  let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
                  quill.insertText(range.index, '\n');
                }
              },
              enter:       {
                key:     13,
                handler: (range, ctx) => {
                  if (!this.stopOnEnter) {
                    let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
                    quill.insertText(range.index, '\n');
                  }
                }
              }
            }
          }
        }
      }


      // magicUrl: magicUrlSettings
      return this.screenSizeId >= 3 ? editorSettings : editorSettingsSmall
    }
  },
  methods:    {
    onKeyPress(quill) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const exp        = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/g
        const exp2       = /\w+\/tasks\//g
        let text         = quill.getText();
        let replaceText  = text.match(exp);
        let replaceText2 = text.match(exp2);
        if (replaceText) {
          replaceText.forEach((txt, idx) => {
            let update = true
            if (replaceText2) {
              replaceText2.every((t, i) => {
                if (txt.indexOf(replaceText2[i]) > -1) update = false;
              });
            }
            if (update) {
              const indexes = [...text.matchAll(new RegExp(replaceText[idx], 'gi'))].map(a => a.index);
              indexes.forEach(index => {

                let str = replaceText[idx];
                if (str.substring(0, 7) !== 'http://' && str.substring(0, 8) !== 'https://')
                  str = 'https://' + str;
                quill.deleteText(index, replaceText[idx].length);
                quill.insertText(index, replaceText[idx], 'link', str);
              })
            }
          })
        }
      }, 500)
    },
    onTextChange() {
      let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
      this.$emit('onTextChange', quill);
    },
    onReady(editor) {
      editor.root.addEventListener('paste', this.handlePaste);
    },
    async handlePaste(event) {
      // Handle the paste event
      const clipboardData = event.clipboardData || window.clipboardData;
      const file          = clipboardData && clipboardData.files && clipboardData.files[0];
      if (file) {
        let fileExtension = file.name.split('.').pop();
        let fileName      = `${new Date().getTime()}.${fileExtension}`;
        let renameFile    = new File([file], fileName, {type: file.type, lastModified: file.lastModified});
        if (this.fileTypeIs('image', fileExtension)) {
          let tmpFileSrc = await this.fileToDataURL(renameFile);
          this.$refs[`inputRichTextEditFile${this._uid}`].show();
          this.tmpFile.src  = '';
          this.tmpFile.name = '';
          setTimeout(() => {
            this.tmpFile.src  = tmpFileSrc;
            this.tmpFile.name = fileName;
          }, 250);
        }
      }
    },
    async uploadCrop() {
      try {
        this.$refs['input-rich-editor-loading-' + this._uid].show();
        let file = await this.$refs[`inputRichTextEditFileCropper${this._uid}`].getFile();
        let res  = await this.uploadFile([file]);
        if (this.auxCursorLocation !== null && this.auxEditor !== null) {
          this.auxEditor.insertEmbed(this.auxCursorLocation, "image", `${app.apiURL}/file/files/${this.uploadOptions.campaign_id}/${res.created_files[0].id}`);
          this.auxCursorLocation = null;
          this.auxEditor         = null;
        } else {
          let fileSrc = `${app.apiURL}/file/files/${this.uploadOptions.campaign_id}/${res.created_files[0].id}`;
          const image = this.input.match(/(data:image\/[^;]+;base64[^"]+)/g)[0];
          this.input  = this.input.replace(image, fileSrc);
        }
        this.$refs['input-rich-editor-loading-' + this._uid].hide();
        this.$refs[`inputRichTextEditFile${this._uid}`].hide();
      } catch (err) {
        this.$refs['input-rich-editor-loading-' + this._uid].hide();
        console.log(err);
        this.cancelCrop();
      }
    },
    cancelCrop() {
      this.auxCursorLocation = null;
      this.auxEditor         = null;
      const aux              = this.input && this.input.length > 0 ? this.input.match(/(data:image\/[^;]+;base64[^"]+)/g) : null;
      if (aux) this.input = this.input.replace(aux[0], '');
      this.$refs[`inputRichTextEditFile${this._uid}`].hide();
    },
    fileToDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader     = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror   = () => {
          reject(new Error("Failed to convert file to Data URL"));
        };
        reader.readAsDataURL(file);
      });
    },
    async uploadFile(files) {
      try {
        const result = await app.data.create("file.file", this.uploadOptions, files);
        //app.toast("Files Uploaded Successfully", "success");
        return result;
      } catch (err) {
        let uploadErrors;
        console.log('KS-APP: ', err);
        if (Array.isArray(err)) uploadErrors = err.map(err => err.error_text);
        else uploadErrors = [err];
        app.toast(`Upload Error: ${uploadErrors[0]}`, "danger");
        throw err;
      }
    },
    async imageAdded(file, Editor, cursorLocation, resetUploader) {
      try {
        this.$refs['input-rich-editor-loading-' + this._uid].show();
        let fileExtension      = file.name.split('.').pop();
        let fileName           = `${new Date().getTime()}.${fileExtension}`;
        let renameFile         = new File([file], fileName, {type: file.type, lastModified: file.lastModified});
        this.auxEditor         = Editor;
        this.auxCursorLocation = cursorLocation;
        let tmpFileSrc         = await this.fileToDataURL(renameFile);
        this.$refs[`inputRichTextEditFile${this._uid}`].show();
        this.tmpFile.src  = '';
        this.tmpFile.name = '';
        setTimeout(() => {
          this.tmpFile.src  = tmpFileSrc;
          this.tmpFile.name = fileName;
        }, 250);
        resetUploader();
        this.$refs['input-rich-editor-loading-' + this._uid].hide();
      } catch (err) {
        this.$refs['input-rich-editor-loading-' + this._uid].hide();
        console.log('KS-APP: ', err);
      }
    },
    validate_input() {
      this.errors = [];
      if (this.required) {
        if (!this.input || `${this.input}`.length == 0) {
          this.errors.push('This Field is Required');
          return false
        }
      }
      return true;
    },
    /*onKeyPress() {
      this.$emit('onKeyPress', this);
    },*/
    /*onKeyPressEnter() {
      this.$emit('onKeyPressEnter', this);
    },*/
    onKeyDownTab() {
      this.$emit('onKeyDownTab', this);
    },
    onBlur() {
      this.$emit('onBlur', this);
    },
    onFocus() {
      this.$emit('onFocus', this);
    },
    onClick() {
      this.$emit('onClick', this);
    },
    onChange() {
      this.$emit('onChange', this);
    }
  },
  mounted() {
    if (typeof this.defaultValue !== 'undefined') this.input = this.defaultValue;
    if (this.dataSource !== null) this.$parent.data_provider_ref.inputs[this.dataSource] = this;

    this.editor = this.$refs[`rich-editor-ref-${this._uid}`];
    let quill = this.$refs[`rich-editor-ref-${this._uid}`].quill;
    /*quill.root.addEventListener('keydown', evt => {
      this.$emit('onKeyPressEnter', quill);
    });*/
    let _this = this;
    quill.root.addEventListener('keydown', evt => {
      if (evt.key === 'Enter' && !evt.shiftKey) {
        evt.preventDefault();
        _this.$emit('onKeyPressEnter', quill);
      }
      if (evt.key === 'Enter' && evt.shiftKey) {
        _this.$emit('onKeyPressShiftEnter', quill);
      }
      _this.$emit('onKeyPress', quill);
      if (_this.stopOnEnter) return;
      _this.onKeyPress(quill);
    });
    this.$emit('onMounted', this);
  }
  ,
  data() {
    return {
      editor:            null,
      l_input:           this.value,
      showWysiwyg:       true,
      errors:            [],
      tmpFile:           {
        src:  null,
        name: null
      },
      auxEditor:         null,
      auxCursorLocation: null
    }
  }
}
</script>
<style>
.ql-container {
  height: calc(100% - 47px) !important;
}

.ql-editor {
  height: 100% !important;
  min-height: 100% !important;
}
</style>